import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { css } from 'lit';
import type { OptimiveWrapperStylesLoader, OptimoveSdkConfigsLoader } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OPTIMOVE_SDK_CONFIG_LOADER: DiToken<OptimoveSdkConfigsLoader> = new DiToken<OptimoveSdkConfigsLoader>(
  'optimoveSdkConfigs'
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const OPTIMOVE_WRAPPER_STYLES_LOADER: DiToken<OptimiveWrapperStylesLoader> =
  new DiToken<OptimiveWrapperStylesLoader>('OPTIMOVE_WRAPPER_STYLES_LOADER', {
    factory: () => async () => css``
  });
